module.exports = "/virtual-football-league/img/amblems/left/logos/Fake_ManchesterCity.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Fake_ManchesterCity.png
// module id = 2087
// module chunks = 4